module.exports = __webpack_public_path__ + "img/zhinengzhizao_dugeng.adfb193e.png";